import { render } from "./PresenceTable.vue?vue&type=template&id=13b45df8"
import script from "./PresenceTable.vue?vue&type=script&lang=js"
export * from "./PresenceTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__